import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { affiliateFirstCode, loadPartners, markWelcome, setAffiliate } from '@/lib/affiliate';
import { normalizeSlug } from '@/lib/affiliate-rules';

/**
 * ?ref=NAME (also the target of short links like /nicole): attributes the
 * visit to the partner (last click wins), queues the welcome note and hands
 * the partner's first-purchase code to the existing ?code= flow.
 */
export const AffiliateCapture = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const slug = normalizeSlug(params.get('ref'));
    if (!slug) return;
    let cancelled = false;
    (async () => {
      const partner = (await loadPartners()).find((p) => p.slug === slug);
      if (cancelled) return;
      params.delete('ref');
      if (partner) {
        setAffiliate(partner.slug, partner.name, 'link');
        markWelcome(partner.name);
        const code = await affiliateFirstCode(partner.slug);
        if (cancelled) return;
        if (code) params.set('code', code);
      }
      const q = params.toString();
      navigate(`${pathname}${q ? `?${q}` : ''}`, { replace: true });
    })();
    return () => { cancelled = true; };
  }, [pathname, search, navigate]);

  return null;
};
